import { render, staticRenderFns } from "./ProfileSkillsEditor.vue?vue&type=template&id=7382e91a&scoped=true"
import script from "./ProfileSkillsEditor.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProfileSkillsEditor.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ProfileSkillsEditor.vue?vue&type=style&index=0&id=7382e91a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7382e91a",
  null
  
)

export default component.exports